import { UserBaseInfo } from '@users/models/user-base-info';

export class UsersState {
    customers: UserBaseInfo[] = [];
}